import { Skeleton } from "antd";
import React, { useEffect, useState } from "react";

const InitialChat = () => {
    const [name, setName] = useState('');
    const [suggetions, setSuggetions] = useState([]);
    const [seletedIdx, setSeletedIdx] = useState(-1);
    const [apiDone, setApiDone] = useState(false); // ✅ track if both APIs are done

    useEffect(() => {
        const fetchData = async () => {
            await Promise.all([getCompanyName(), getSuggetions()]);
            setApiDone(true); // ✅ mark as done after both calls
        };
        fetchData();
    }, []);

    const getCompanyName = async () => {
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/get_client_identity?user_id=${localStorage.getItem('user_id') || ''}`
            );

            if (response.ok) {
                const responseData = await response.json();
                const nameFromValue = responseData?.analysis_results?.client_name?.value;
                const nameFromDetails = responseData?.analysis_results?.client_name?.details?.['BANK_transactions-client_name']?.[0];
                setName(nameFromValue || nameFromDetails || '');
            } else {
                setName('');
            }
        } catch (error) {
            console.error(error);
            setName('');
        }
    };

    const getSuggetions = async () => {
        try {
            const response = await fetch(
                `${process.env.REACT_APP_API_URL}/analyze_user_data?user_id=${localStorage.getItem('user_id') || ''}`
            );

            if (response.ok) {
                const responseData = await response.json();
                const queries = responseData?.analysis_results?.analysis_results?.suggested_queries;
                setSuggetions(Array.isArray(queries) ? queries : []);
            } else {
                setSuggetions([]);
            }
        } catch (error) {
            console.error(error);
            setSuggetions([]);
        }
    };

    const setInputVal = (val) => {
        const collection = document.getElementsByClassName('react-chatbot-kit-chat-input');
        const inputField = [...collection];
        if (inputField[0]) inputField[0].value = val;
    };

    return (
        <>
            {apiDone ? (
                <>
                    <span>Hey there! I am </span>
                    <i>{`${process.env.REACT_APP_BOT_NAME || "Bodhi Fin Bot"}`}</i>
                    <span>. I will help you analyze financial data of </span>
                    <span className="text-violet-800 font-extrabold">
                        {name || "Akal Hire Purchase"}.
                    </span>
                    <span> Here are some suggestions to start with.</span>

                    <div className="flex justify-start flex-wrap">
                        {suggetions.length > 0 ? (
                            suggetions.map((sug, idx) => (
                                <div
                                    key={`suggestion-${idx}`}
                                    style={{
                                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                        backgroundColor: '#f9f9f9',
                                        border: '1px solid #ddd',
                                    }}
                                    className={`p-2 mr-1 my-2 cursor-pointer hover:text-blue-500 text-xs rounded-md ${idx === seletedIdx ? 'font-extrabold' : ''}`}
                                    onClick={() => {
                                        setInputVal(sug);
                                        setSeletedIdx(idx);
                                    }}
                                >
                                    {sug}
                                </div>
                            ))
                        ) : (
                            <span className="text-sm text-gray-500 mt-2">No suggestions found.</span>
                        )}
                    </div>
                </>
            ) : (
                <>
                    <div className="text-center font-bold relative w-full">
                        <span className="text-sm">Analyzing your data...</span>
                        <Skeleton.Button
                            active={true}
                            size={'default'}
                            shape={'default'}
                            block={true}
                            className="absolute left-0 top-[-2px] w-[100%]"
                        />
                    </div>
                    <div className="flex justify-between flex-wrap mt-4">
                        <Skeleton.Button
                            active={true}
                            size={'default'}
                            shape={'default'}
                            block={false}
                            style={{ width: '200px' }}
                        />
                        <Skeleton.Button
                            active={true}
                            size={'default'}
                            shape={'default'}
                            block={false}
                            style={{ width: '200px' }}
                        />
                        <Skeleton.Button
                            active={true}
                            size={'default'}
                            shape={'default'}
                            block={false}
                            style={{ width: '200px' }}
                        />
                    </div>
                </>
            )}
        </>
    );
};

export default InitialChat;
